import {doGet, doPost} from "./ApiService";
import localStorageService from "./localStorageService";
import axios from "axios";

export const BASE_URL = process.env.REACT_APP_API_USER || '/api';

export const getUserProfile = (accessToken) => {
    const headers = {}
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`
    }
    return doGet(`${BASE_URL}/profile`, null, headers)
}

export const getLoggedUser = () => {
    return localStorageService.getItem(`auth_user`)
}

export const getLoggedToken = () => {
    const loggedToken = axios.defaults.headers.common["Authorization"]
    if (!loggedToken) return null

    return loggedToken.split("Bearer").join("").trim()
}

export const findAllUser = (query) => {
    return doGet(`${BASE_URL}/user`, query)
}

export const saveUser = (data) => {
    return doPost(`${BASE_URL}/user`, data)
}

export const getUserOrganizations = (userId, query) => {
    return doGet(`${BASE_URL}/user/${userId}/organization`, query)
}